<template>
  <section class="max-w-3xl mx-auto px-4 py-10 space-y-8">
    <header class="space-y-2">
      <h1 class="text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-gray-100">About Rozay</h1>
      <p class="text-sm text-gray-600 dark:text-gray-300">
        Rozay is a Pakistan-focused Ramadan and Islamic utility platform built to keep daily fasting information simple,
        clear, and easy to access.
      </p>
    </header>

    <div class="space-y-6 text-sm text-gray-700 dark:text-gray-300 leading-6">
      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">What We Offer</h2>
        <ul class="list-disc pl-5 space-y-1">
          <li>Sehri and Iftar timings by city</li>
          <li>Ramadan calendar support</li>
          <li>Roza rules and simple explanations</li>
          <li>Dua information for Ramadan</li>
          <li>Fitrana guidance</li>
          <li>Lailat-ul-Qadr information</li>
        </ul>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">Our Goal</h2>
        <p>
          Our goal is to provide clean and practical Islamic information that helps users quickly check essential
          Ramadan details without confusion.
        </p>
      </section>

      <section class="space-y-2">
        <h2 class="text-lg font-medium text-gray-900 dark:text-gray-100">Important Note</h2>
        <p>
          Timings and dates may vary slightly based on local mosque announcements, moon sighting, and method
          differences. For final decisions, please follow your local mosque.
        </p>
      </section>
    </div>
  </section>
</template>
